import styled from 'styled-components';

export const Header = {
    Container: styled.div`
        padding: 10px;
    `,
}

export const Body = {
    Container: styled.div`
        padding: 10px;
    `,
    FormWrapper: styled.div`
        display: flex;
        flex-direction: column;
        gap: 10px;
    `,
    ButtonWrapper: styled.div`
        margin-top: 20px;
        button{
            width: 100px;
            margin-left: auto;
        }
    `,
}
